module.exports = __webpack_public_path__ + "media/images/icon-svg/mastercard-539f536a28553519a8e634a6ce46713a.svg";